<template>
  <div class="view box grow allowlist-container">
    <page-headers
      :header="'Allowlist'"
      :breadcrumbs="breadcrumbs"
      :is-border="true"
      documentation="page-allowlist"
      class="box"
    >
    </page-headers>
    <div class="full-width">
      <span class="material-icons float-right cursor-pointer" @click="gotoAllowlist">close</span>
    </div>
    <allowlist-form-prefill
      v-if="activeView === 'detection'"
      class="allowlist-form full-height"
      @create-success="gotoAllowlist"
    ></allowlist-form-prefill>
    <allowlist-form
      v-else
      class="allowlist-form full-height"
      :operation="activeView"
      :item="selectedAllowlist"
      @create-success="gotoAllowlist"
    ></allowlist-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import PageHeaders from '@/components/layout/PageHeaders.vue'
import AllowlistForm from '@/components/form/allowlist/AllowlistForm.vue'
import AllowlistFormPrefill from '@/components/form/allowlist/AllowlistFormPrefill.vue'

export default {
  name: 'AllowlistWorkflow',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  data () {
    return {
      breadcrumbs: [{ title: 'Configuration' }, { title: 'AllowList', to: '/rules/allowlist' }, { title: 'Create' }],
      activeView: '',
      prevRoute: {},
      selectedAllowlist: {}
    }
  },
  methods: {
    gotoAllowlist () {
      let routeTo = this.breadcrumbs[1].to.name
      if (_.isUndefined(this.breadcrumbs[1].to.name)) {
        routeTo = 'allowlist'
      }
      this.$router.push({
        name: routeTo,
        params: this.breadcrumbs[1].to.params,
        query: this.breadcrumbs[1].to.query
      })
    }
  },
  created () {
    this.activeView = this.$route.path.split('/').reverse()[0]
    if (this.activeView === 'edit') {
      this.breadcrumbs[2].title = 'Edit'
      this.selectedAllowlist = this.selectedEditedAllowlist
    } else if (this.activeView === 'duplicate') {
      this.breadcrumbs[2].title = 'Duplicate'
      this.selectedAllowlist = this.selectedCopiedAllowlist
    }
  },
  computed: {
    ...mapGetters([
      'rulesAllowlistReqStatus',
      'rulesAllowlist',
      'rulesListReqStatus',
      'allRulesList',
      'selectedEditedAllowlist',
      'selectedCopiedAllowlist'
    ])
  },
  watch: {
    prevRoute (newVal, oldVal) {
      if (!_.isEmpty(newVal) && newVal.path !== '/') {
        this.breadcrumbs[1].to = { name: newVal.name, params: newVal.params, query: newVal.query }
      }
    }
  },
  components: {
    PageHeaders,
    AllowlistForm,
    AllowlistFormPrefill
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.allowlist-form {
  margin-left: 15%;
  margin-right: 15%;
  margin-top: 5%;
}

.table-toolbar {
  button {
    max-height: 36px;
  }
}

.error {
  text-align: center;
  color: var(--text-color-danger);
}

.el-dialog__wrapper {
  overflow: unset;
}

.el-dialog__wrapper >>> .el-dialog__body {
  overflow: auto;
  height: 400px;
}

.icon-text-button {
  background: var(--main-blue);
  padding: 5px 10px;

  span {
    .c-icon {
      color: white;
      font-size: 1.2em;
      vertical-align: text-bottom;
      margin-right: 5px;
    }
    span {
      color: white;
      margin-bottom: 6px;
    }
  }
}

.help-text-button {
  line-height: 28px;
  padding: 0px;
}

.material-icons {
  vertical-align: middle;
  color: var(--gray-500);
}

>>> .el-dialog__body {
  .el-select {
    width: 100%;
  }

  .el-dropdown {
    width: 100%;
    box-sizing: border-box;
    background-color: white;
    background-image: none;
    border: none;

    .el-select {
      color: var(--border-color);
      border: 1px solid var(--border-color);
      opacity: 0.8;
      height: 40px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 660px;

      &:focus,
      &.focusing {
        border-color: #409eff;
        outline: 0;
      }

      > span {
        padding-left: 10px;
      }
      > i {
        padding-right: 10px;
      }
    }

    .el-icon-arrow-down {
      vertical-align: bottom;
      line-height: 40px;
      margin-right: 24px;
    }
  }
}

.icon-arrow-down {
  mask-repeat: no-repeat;
  mask-size: cover;
  vertical-align: middle;
  line-height: 36px;
  height: 14px;
  width: 14px;
  margin-top: 10px;
}

.icon-skull,
.icon-star,
.icon-file-upload {
  display: inline-block;
  vertical-align: middle;
  mask-repeat: no-repeat;
  mask-size: cover;
  margin: 0px 5px;
}

.icon-skull,
.icon-star {
  height: 14px;
  width: 14px;
}

.icon-skull {
  background: var(--main-amaranth);
}

.icon-star {
  background: var(--main-blue);
}

.el-dropdown-link .material-icons {
  line-height: 40px;
}

.el-dropdown_footer {
  padding: 10px 20px 10px;
  border: 1px solid var(--border-color);

  .material-icons {
    line-height: 26px;
    border: 1px solid var(--border-color);
  }

  .el-col {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 500px;
  }
}

.el-divider--vertical {
  margin: 0px;
}

.search-select-dropdown {
  >>> .el-input__inner {
    border-radius: 0px;
  }

  >>> .el-dropdown-menu__item {
    padding: 0px;

    > div {
      border: 1px solid var(--border-color);
      border-top: 0px;
    }

    &:hover {
      background-color: #f5f7fa;
      color: inherit;
    }

    &.row-selected {
      background: var(--denim-50) !important;
    }

    > span {
      vertical-align: middle;
    }

    .description {
      max-width: 600px;
      word-break: break-word;
      line-height: 20px;
    }

    .el-row {
      padding: 0px 20px;

      &.row-drawer {
        background: white;
      }
    }

    .el-col-19 {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}

.row-border {
  border: 1px solid var(--border-color);

  &.list-row {
    border-bottom: 0px;
  }
}

.image-upload {
  .icon-file-upload {
    background: var(--gray-500);
  }

  #ruleset_file {
    z-index: 99;
    opacity: 0;
    height: 20px;
    position: relative;
    left: -120px;
    cursor: pointer;
  }
}

.custom-value-search {
  >>> .el-input__inner {
    border-radius: 0px;
    border-bottom: 0px;
  }

  .material-icons {
    line-height: 40px;
  }
}

.el-form-item:not(.is-error) {
  .custom-value-input {
    >>> .el-input__inner,
    >>> .el-textarea__inner {
      font-family: var(--main-font-family);
      border: 1px solid var(--border-color);
      border-radius: 0px;
      word-break: keep-all;
    }
  }
}

.el-form-item.is-error {
  .custom-value-input {
    >>> .el-input__inner,
    >>> .el-textarea__inner {
      font-family: var(--main-font-family);
      border-radius: 0px;
      word-break: keep-all;
    }
  }
}

.custom-value-input {
  &.el-row {
    padding-top: 10px;
  }

  .add-button {
    line-height: 25px;

    .material-icons {
      font-size: 1.5em;
      vertical-align: middle;
    }
  }
}

.helper-action.icon-text-button {
  width: 100%;
  background: white;
  color: var(--denim-600);
  padding: 0px 10px;

  i,
  span {
    color: var(--denim-600);
  }
}

.clear-input {
  cursor: pointer;
  margin-left: 8px;
}

.list-row {
  >>> .el-input__inner {
    border: none;
  }
}

>>> .el-collapse-item__header {
  height: 40px;
  line-height: 40px;
  background-color: var(--gray-50);
  border-bottom: 1px solid var(--border-color);
  padding-left: 15px;
  font-size: 10px;
  font-weight: normal;
  color: inherit;
  line-height: 32px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

>>> .el-collapse-item__content {
  padding-top: 15px;
}

.view.box.grow.allowlist-container{
  height:100%;
  overflow-x: hidden;
  overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// src/views/admin/AllowlistWorkflow.vue